
import { Component, Vue } from "vue-property-decorator";
import httpClient from "../../store/httpClient";

interface WerkstoffBezeichnungDto {
	languageCode: string;
	bezeichnung: string;
}

interface WerkstoffManagementDto {
	id: number;
	name: string;
	bezeichnungen: WerkstoffBezeichnungDto[];
}

interface WerkstoffRow {
	id: number;
	name: string;
	bezeichnungen: Record<string, string>;
}

const languages = [
	{ code: "de-CH", text: "Deutsch" },
	{ code: "fr-FR", text: "Französisch" },
	{ code: "en-GB", text: "Englisch" },
	{ code: "it-CH", text: "Italienisch" },
];

@Component
export default class Werkstoffe extends Vue {
	private loading: boolean = false;
	private werkstoffe: WerkstoffRow[] = [];
	private languages = languages;

	private get headers() {
		return [
			{ value: "name", text: "Name", sortable: false },
			...this.languages.map((language) => ({
				value: language.code,
				text: language.text,
				sortable: false,
			})),
		];
	}

	private mounted() {
		this.loadWerkstoffe();
	}

	private async loadWerkstoffe() {
		try {
			this.loading = true;
			const response = await httpClient().get("Material/GetWerkstoffeForManagement");
			this.werkstoffe = (response.data as WerkstoffManagementDto[])
				.map((werkstoff) => ({
					id: werkstoff.id,
					name: werkstoff.name,
					bezeichnungen: this.languages.reduce(
						(map, language) => {
							const bezeichnung = werkstoff.bezeichnungen.find(
								(b) => b.languageCode === language.code
							);
							map[language.code] = bezeichnung ? bezeichnung.bezeichnung : "";
							return map;
						},
						{} as Record<string, string>
					),
				}))
				.sort((a, b) => a.name.localeCompare(b.name));
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Beim Laden der Werkstoffe ist ein Fehler aufgetreten."
			);
		} finally {
			this.loading = false;
		}
	}

	private async saveBezeichnung(werkstoff: WerkstoffRow, languageCode: string) {
		try {
			const bezeichnung = werkstoff.bezeichnungen[languageCode] || "";
			await httpClient().post(
				`Material/SaveWerkstoffBezeichnung?werkstoffId=${werkstoff.id}&languageCode=${languageCode}&bezeichnung=${encodeURIComponent(
					bezeichnung
				)}`
			);
			this.$store.commit("setSnackbarText", "Bezeichnung gespeichert.");
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Beim Speichern der Bezeichnung ist ein Fehler aufgetreten."
			);
		}
	}
}
